/* eslint-disable eqeqeq */
export function validateChanged<Payload, Model extends Record<string, unknown>>(
  formValues: Payload,
  record: Model
): boolean {
  return Object.entries(formValues ?? {}).some(([field, value]) => {
    return value != record[field];
  });
}
